import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetNameParams } from '../../../spacesPlatform/utils/actionParams';

export class RenameDatasourceRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(params: ISetNameParams) {
    super('renameDatasource', params);
  }
}
